export default __webpack_public_path__ + "static/media/playup-logo.f1d73fe6.svg";